import { Table, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { IRedeemCoupon } from "@interfaces";

import { memo } from "react";
import dayjs from "dayjs";

interface IProps {
  data: IRedeemCoupon[];
  callback: () => void;
}
export const RedeemTable = memo(({ data }: IProps) => {
  const { t } = useTranslation();

  const dataSource: IRedeemCoupon[] = data;

  const columns: ColumnsType<IRedeemCoupon> = [
    {
      title: t("page.coupon_code"),
      dataIndex: "couponCode",
      key: "1",
    },
    {
      title: t("page.service_category"),
      dataIndex: "category",
      key: "7",
    },
    {
      title: t("page.client_name"),
      dataIndex: "clientName",
      key: "2",
      sorter: (a, b) => {
        if (a?.clientName && b?.clientName) {
          return a?.clientName.localeCompare(b?.clientName);
        } else {
          return 1;
        }
      },
    },
    {
      title: <Tooltip title={t("page.coupon_generated_date")}> {t("page.cg_date")}</Tooltip>,
      dataIndex: "cgDate",
      key: "3",
      render: (data) => <span>{dayjs(data).format("DD-MM-YYYY HH:mm")}</span>,
    },
    {
      title: <Tooltip title={t("page.coupon_redeemed_date")}> {t("page.cr_date")}</Tooltip>,
      dataIndex: "crDate",
      key: "4",
      render: (data) => <span>{dayjs(data).format("DD-MM-YYYY HH:mm")}</span>,
    },
    {
      title: t("page.cr_provider_name"),
      dataIndex: "clinicName",
      key: "5",
      sorter: (a, b) => {
        if (a?.clinicName && b?.clinicName) {
          return a?.clinicName.localeCompare(b?.clinicName);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.cr_redeem_provider_name"),
      dataIndex: "doctorName",
      key: "6",
      sorter: (a, b) => {
        if (a?.doctorName && b?.doctorName) {
          return a?.doctorName.localeCompare(b?.doctorName);
        } else {
          return 1;
        }
      },
    },
  ];

  return (
    <Table dataSource={dataSource} rowKey={"couponFamilyId"} columns={columns} pagination={false} />
  );
});
